import styled from "styled-components";
import { registrationScrollBodyStyles } from "../RegistrationLayout/registrationScrollBodyStyles";
import { registrationCardHeaderStyles } from "../RegistrationLayout/registrationFlowLayout";
import { registrationFormStyles } from "../RegistrationLayout/registrationFormStyles";
import {
  REGISTRATION_FOCUS_RING,
  REGISTRATION_FONT_BODY,
  REGISTRATION_FOREST,
  REGISTRATION_LINK,
  REGISTRATION_ON_PRIMARY,
  REGISTRATION_PRIMARY,
  REGISTRATION_PRIMARY_DARK,
} from "../RegistrationLayout/registrationTheme";

const RegisterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: transparent;
  font-family: ${REGISTRATION_FONT_BODY};

  .scroll-body {
    ${registrationScrollBodyStyles}
  }

  .registration-card-header {
    ${registrationCardHeaderStyles}
  }

  .content-card-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 32px 20px calc(28px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    @media (min-width: 600px) {
      padding: 32px 32px calc(36px + env(safe-area-inset-bottom, 0px));
    }
  }

  .form-hint-link {
    color: ${REGISTRATION_LINK};
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: inherit;

    &:hover {
      text-decoration: underline;
    }
  }

  .reg-code-row {
    position: relative;
  }

  .reg-code-close {
    position: absolute;
    right: 12px;
    top: 45px;
    font-size: 18px;
    cursor: pointer;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    background: none;
    border: none;
    padding: 0;
    line-height: 1;
  }

  .field-group-intro {
    font-size: 13px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.55;
    margin-bottom: 16px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .why-box {
    margin-bottom: 16px;
  }

  .why-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: ${REGISTRATION_LINK};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .why-body {
    font-size: 12px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.6;
    margin-top: 8px;
    padding: 10px 12px;
    background: rgba(174, 206, 56, 0.08);
    border-radius: 10px;
    border-left: 3px solid #aece38;
  }

  .why-body[hidden] {
    display: none;
  }

  .knowledge-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 28px;
  }

  .know-opt {
    border: 2px solid rgba(30, 42, 53, 0.12);
    border-radius: 10px;
    padding: 16px 18px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 14px;
    background: #ffffff;
    text-align: left;
    width: 100%;
    font-family: ${REGISTRATION_FONT_BODY};

    &:hover {
      border-color: #aece38;
      background: rgba(174, 206, 56, 0.08);
    }

    &.selected {
      border-color: #aece38;
      background: rgba(174, 206, 56, 0.1);
    }
  }

  .know-opt-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(30, 42, 53, 0.18);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .know-opt.selected .know-opt-dot {
    background: ${REGISTRATION_PRIMARY};
    border-color: ${REGISTRATION_PRIMARY};
    color: ${REGISTRATION_ON_PRIMARY};
  }

  .know-opt-title {
    font-size: 14px;
    font-weight: 600;
    color: #5a6b80;
    margin-bottom: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .know-opt-desc {
    font-size: 12px;
    color: ${REGISTRATION_FOREST};
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .terms-agreement {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 20px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 13px;
    line-height: 1.55;
    color: #5a6b80;
  }

  .terms-agreement-checkbox {
    margin-top: 3px;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    accent-color: #aece38;
    cursor: pointer;

    &:focus-visible {
      outline: 3px solid ${REGISTRATION_FOCUS_RING};
      outline-offset: 2px;
    }
  }

  .terms-agreement-text {
    flex: 1;
    min-width: 0;
    margin: 0;
  }

  .terms-agreement-agree {
    cursor: pointer;
  }

  .terms-link {
    color: ${REGISTRATION_LINK};
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: inherit;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: ${REGISTRATION_ON_PRIMARY};
    }
  }

  .continue-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 14px 28px;
    border-radius: 999px;
    border: none;
    background: ${REGISTRATION_PRIMARY};
    color: ${REGISTRATION_ON_PRIMARY};
    font-family: ${REGISTRATION_FONT_BODY};
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 8px;

    &:hover:not(:disabled) {
      background: ${REGISTRATION_PRIMARY_DARK};
      color: ${REGISTRATION_ON_PRIMARY};
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(174, 206, 56, 0.35);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  }

  ${registrationFormStyles}
`;

export default RegisterWrapper;
